"use client";
import dynamic from "next/dynamic"
import homepageImg from "../images/leasing.webp";
import {Button, Card, CardBody, CardFooter, CardHeader, Input, Typography,
    Checkbox,
    Spinner,
    IconButton} from "@material-tailwind/react";
import Link from "next/link";
import React, {useEffect, useRef, useState} from "react";
import AssetCard from "@/components/AssetCard";
import {apiGetLayouts} from "@/api/asset/GetAssetLayouts";
import {PmStore} from "@/state";
import { apiGetAssetTypes, apiGetLocations, apiMyAssetSearch} from "@/api/asset";
import {useRouter} from "next/navigation";
import { PrimaryButton } from "@/components/StyledButtons";
import CustomSelect from "@/components/CustomSelect";


export default function Home() {
    const state = PmStore();
    let navigate = useRouter();
    const [Assets,SetAssets] = useState([]);
    const [Loading, SetLoading] = useState(false);


    const [Layouts, SetLayouts] = useState([]);
    const [Types, SetTypes] = useState([]);
    const [Locations, SetLocations] = useState([]);

    const [State, SetState] = useState({
        LocationFiltered: false,
        LocationLoading: false,
        Terms: null,
        SelectedLocationId: null,
        SelectedLayoutId: null,
        SelectedTypeId: null,
    });


    let SearchTerms = useRef({
        Terms: null,
        LocationId: null,
        LayoutId: null,
        TypeId: null,
    });


    function GetLayouts()
    {
        if(!state?.selectedOrganization?.id) return;
        apiGetLayouts(state?.selectedOrganization?.id).then((data) => SetLayouts(data));
    }
    function GetLocations()
    {
        if(!state?.selectedOrganization?.id) return;
        apiGetLocations(state?.selectedOrganization?.id).then((data) => SetLocations(data));
    }
    function GetAssetTypes()
    {
        if(!state?.selectedOrganization?.id) return;
        apiGetAssetTypes(state?.selectedOrganization?.id).then((data) => SetTypes(data));
    }

    function SearchAssets()
    {
        console.log('search called');
        SetLoading(true);

        if(!state?.selectedOrganization?.id) {
            SetLoading(false);
            return;
        }

        let locations = [];
        if(SearchTerms.current.LocationId) locations.push(SearchTerms.current.LocationId);

        let types = [];
        if(SearchTerms.current.TypeId) types.push(SearchTerms.current.TypeId);

        let layouts = [];
        if(SearchTerms.current.LayoutId) layouts.push(SearchTerms.current.LayoutId);

        apiMyAssetSearch(state?.selectedOrganization?.id, SearchTerms.current.Terms, null, locations, types,  layouts)
            .then((data) => {
                SetAssets(data.items);
                SetLoading(false);
            })
            .catch((error) => {
                console.error('Search error:', error);
                SetLoading(false);
            });
    }


    useEffect(() => {
        if(state?.selectedOrganization?.id) {
            SearchAssets();
            GetLayouts();
            GetAssetTypes();
            GetLocations();
        }
    }, [state?.selectedOrganization?.id]);


  return (
      <div className="w-full bg-white">
          {/* Hero Section */}
          <div className="relative h-[600px] w-full overflow-hidden">
              <img
                  src={homepageImg.src}
                  alt="background"
                  className="h-full w-full object-cover"
              />
              <div className="absolute top-0 left-0 h-full w-full bg-black/50"/>
              <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-b from-black/30 to-black/50"/>

              {/* Hero Content */}
              <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center text-white px-4 max-w-4xl mx-auto">
                      <Typography variant="h1" className="mb-4 text-4xl md:text-6xl font-bold">
                          Welcome to Rental Flow
                      </Typography>
                      <Typography variant="lead" className="mb-8 text-lg md:text-xl opacity-90">
                          Find your perfect space today
                      </Typography>

                      {/* Search Bar */}
                      <form onSubmit={(e) => {
                          e.preventDefault();
                          SearchAssets()
                          navigate.push("#search-results");
                      }} className="max-w-2xl mx-auto">
                          <div className="flex gap-3 p-3 bg-white/95 backdrop-blur rounded-xl shadow-lg transition-all duration-200 focus-within:ring-2 focus-within:ring-[#0055D4] focus-within:ring-offset-2">
                              <input
                                  type="text"
                                  className="flex-1 px-4 py-3 bg-transparent text-gray-800 placeholder-gray-500 outline-none text-lg !border-none focus:!border-none focus:outline-none focus:ring-0"
                                  style={{ border: 'none', outline: 'none' }}
                                  placeholder="Search for assets and locations"
                                  value={State.Terms || ''}
                                  onChange={(e) => {
                                      SearchTerms.current.Terms = e.target.value;
                                      SetState((prevState) => ({
                                          ...prevState, Terms: e.target.value
                                      }))
                                  }}
                              />
                              <PrimaryButton
                                  type="submit"
                                  className="px-8 flex-shrink-0"
                                  disabled={!State.Terms || State.Terms.trim().length === 0}
                              >
                                  Search
                              </PrimaryButton>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
          {/* Main Content Section */}
          <div className="py-16 bg-gray-50">
              <section className="container mx-auto px-4">
                  <div className="text-center mb-12">
                      <Typography variant="h2" className="mb-4 text-3xl md:text-4xl font-semibold text-gray-900">
                          Explore Our Availability
                      </Typography>
                      <Typography className="text-gray-600 mx-auto max-w-2xl">
                          Keep in mind our availability changes frequently, if you cannot find what you are
                          looking for, please reach out to see what may be coming on the horizon!
                      </Typography>
                  </div>
                  {/* Filter Section */}
                  <div className="mb-8">
                      <div className="bg-white rounded-xl border border-gray-200 p-6">
                          <Typography variant="h6" className="mb-4 font-medium text-gray-900">
                              Refine Your Search
                          </Typography>
                          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
                              <div>
                                  <CustomSelect
                                      label="Locations"
                                      value={State.SelectedLocationId}
                                      options={Locations}
                                      disabled={Locations?.length === 0}
                                      showClear={State.LocationFiltered}
                                      onChange={(value) => {
                                          const scrollPos = window.scrollY;
                                          SearchTerms.current.LocationId = value;
                                          SetState((prevState) => ({
                                              ...prevState,
                                              LocationFiltered: !!value,
                                              SelectedLocationId: value
                                          }))
                                          SearchAssets();
                                          requestAnimationFrame(() => window.scrollTo(0, scrollPos));
                                      }}
                                      onClear={() => {
                                          SearchTerms.current.LocationId = null;
                                          SetState((prevState) => ({
                                              ...prevState,
                                              LocationFiltered: false,
                                              SelectedLocationId: null
                                          }))
                                          SearchAssets();
                                      }}
                                  />
                              </div>

                              <div>
                                  <CustomSelect
                                      label="Layouts"
                                      value={State.SelectedLayoutId}
                                      options={Layouts}
                                      disabled={Layouts?.length === 0}
                                      showClear={State.LayoutsFiltered}
                                      onChange={(value) => {
                                          const scrollPos = window.scrollY;
                                          SearchTerms.current.LayoutId = value;
                                          SetState((prevState) => ({
                                              ...prevState,
                                              LayoutsFiltered: !!value,
                                              SelectedLayoutId: value
                                          }))
                                          SearchAssets();
                                          requestAnimationFrame(() => window.scrollTo(0, scrollPos));
                                      }}
                                      onClear={() => {
                                          SearchTerms.current.LayoutId = null;
                                          SetState((prevState) => ({
                                              ...prevState,
                                              LayoutsFiltered: false,
                                              SelectedLayoutId: null
                                          }))
                                          SearchAssets();
                                      }}
                                  />
                              </div>


                              <div>
                                  <CustomSelect
                                      label="Type"
                                      value={State.SelectedTypeId}
                                      options={Types}
                                      disabled={Types?.length === 0}
                                      showClear={State.TypesFiltered}
                                      onChange={(value) => {
                                          const scrollPos = window.scrollY;
                                          SearchTerms.current.TypeId = value;
                                          SetState((prevState) => ({
                                              ...prevState,
                                              TypesFiltered: !!value,
                                              SelectedTypeId: value
                                          }))
                                          SearchAssets();
                                          requestAnimationFrame(() => window.scrollTo(0, scrollPos));
                                      }}
                                      onClear={() => {
                                          SearchTerms.current.TypeId = null;
                                          SetState((prevState) => ({
                                              ...prevState,
                                              TypesFiltered: false,
                                              SelectedTypeId: null
                                          }))
                                          SearchAssets();
                                      }}
                                  />
                              </div>


                          </div>
                      </div>
                  </div>

                  {/* Search Results */}
                  <div id="search-results">
                      {Loading ? (
                          <div className="flex justify-center py-12">
                              <Spinner className="h-12 w-12" />
                          </div>
                      ) : (
                          <div>
                              {Assets?.length > 0 ? (
                                  <>
                                      <Typography variant="small" className="text-gray-600 mb-4">
                                          Showing {Assets.slice(0, 6).length} of {Assets.length} results
                                      </Typography>
                                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                          {Assets?.slice(0, 6).map((asset, index) => (
                                              <AssetCard key={index} assetId={asset.id}/>
                                          ))}
                                      </div>
                                  </>
                              ) : (
                                  <div className="text-center py-12">
                                      <Typography variant="h6" className="text-gray-500 mb-2">
                                          No properties found
                                      </Typography>
                                      <Typography variant="small" className="text-gray-400">
                                          Try adjusting your search filters
                                      </Typography>
                                  </div>
                              )}
                          </div>
                      )}
                  </div>
              </section>
          </div>


      </div>
  );
}

